import Box from "@mui/material/Box";
import { HOST_STATUS, MAINTENANCE } from "../../../lib/constants.js";
import { keyframes } from "@emotion/react";

export default function HostGraph({ imageAltText, status }) {
  const getColorByStatus = (status) => {
    const hue = {
      [HOST_STATUS.DEAD]: "hue-rotate(140deg)",
      [HOST_STATUS.HURT]: "hue-rotate(190deg)",
      [HOST_STATUS.OK]: "hue-rotate(0deg)",
    };

    return hue[status] || hue[HOST_STATUS.OK];
  };

  const colorBlink = keyframes`
    0%, 100% {
      filter: brightness(0.8) ${getColorByStatus(status)};
    }
    50% {
      filter: brightness(1.2) ${getColorByStatus(status)};
    }
  `;

  return (
    <Box
      display="flex"
      flexGrow={1}
      id="maintenance-page-graph"
      justifyContent="center"
      sx={{ position: "relative" }}
    >
      <Box
        alt={imageAltText}
        component="img"
        src="/assets/host-scan.png"
        sx={{
          animation: `${colorBlink} 2s ease-in-out infinite`,
          height: MAINTENANCE.GRAPH_HEIGHT,
          zIndex: 1,
        }}
      />
    </Box>
  );
}
